import { NavLink } from 'react-router-dom';
import Logo from './Logo';

const links = [
  { to: '/', label: 'Dashboard', icon: '◈' },
  { to: '/orders', label: 'Orders', icon: '☰' },
  { to: '/orders/dispatched', label: 'Dispatched', icon: '➤' },
  { to: '/orders/returned', label: 'Returned', icon: '↩' },
  { to: '/messages', label: 'Messages', icon: '✉' },
  { to: '/returns', label: 'Returns Mgmt', icon: '↺' },
  { to: '/sales-analytics', label: 'Sales', icon: '◉' },
  { to: '/inventory', label: 'Inventory', icon: '▣' },
  { to: '/stock-batches', label: 'Stock Batches', icon: '⊞' },
  { to: '/products', label: 'Products', icon: '◇' },
  { to: '/analytics', label: 'Analytics', icon: '📊' },
  { to: '/profit-distribution', label: 'Profit Distribution', icon: '◎' },
  { to: '/owners', label: 'Owners', icon: '◆' },
];

export default function Sidebar() {
  return (
    <aside className="w-64 min-h-screen glass-sidebar flex flex-col shadow-soft">
      <div className="p-5 border-b border-lumora-secondary/60">
        <Logo size="md" link={false} />
        <p className="text-xs text-lumora-text/50 mt-2 tracking-wide">Super Admin Portal</p>
      </div>
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {links.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/'}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-all duration-200 ${
                isActive
                  ? 'bg-lumora-wood text-lumora-white font-medium shadow-glow'
                  : 'text-lumora-text/60 hover:bg-lumora-white/50 hover:text-lumora-dark-wood'
              }`
            }
          >
            <span className="text-base opacity-80">{link.icon}</span>
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="p-4 border-t border-lumora-secondary/60 text-xs text-lumora-text/40">
        Google Sheets via Apps Script
      </div>
    </aside>
  );
}
